import styled, {css} from 'styled-components';
import {down, up} from 'styled-breakpoints';

export type DrawerVariant = 'default' | 'narrow' | 'wide';

interface DrawerProps {
  children: React.ReactNode;
  variant?: DrawerVariant;
  customWidth?: {
    xl?: string;
    lg?: string;
    md?: string;
  };
  customPadding?: {
    xl?: string;
    lg?: string;
    md?: string;
  };
}

interface DrawerWrapperProps {
  $variant: DrawerVariant;
  $customWidth?: DrawerProps['customWidth'];
  $customPadding?: DrawerProps['customPadding'];
}

const variantConfig = {
  default: {
    width: {xl: '45%', lg: '60%', md: '70%'},
    padding: {xl: '32px 70px', lg: '32px 70px', md: '32px 70px'},
  },
  narrow: {
    width: {xl: '35%', lg: '50%', md: '70%'},
    padding: {xl: '32px 40px', lg: '32px 40px', md: '32px 40px'},
  },
  wide: {
    width: {xl: '60%', lg: '75%', md: '85%'},
    padding: {xl: '32px 80px', lg: '32px 70px', md: '32px 60px'},
  },
};

const Overlay = styled.div`
  z-index: 10;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 1px;
  width: 100%;
  position: fixed;
  background: rgba(39, 50, 64, 0.25);
  will-change: opacity;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
`;

const DrawerWrapper = styled.div<DrawerWrapperProps>`
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  transition: -webkit-transform 0.3s;
  background: white;
  overflow-y: scroll;
  overflow-x: hidden;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition-timing-function: var(--ease-in-out);

  ${({$variant, $customWidth, $customPadding}) => {
    const config = variantConfig[$variant];
    const width = $customWidth || config.width;
    const padding = $customPadding || config.padding;

    return css`
      ${down('md')} {
        width: ${width.md};
        padding: ${padding.md};
      }

      ${up('lg')} {
        width: ${width.lg};
        padding: ${padding.lg};
      }

      ${up('xl')} {
        width: ${width.xl};
        padding: ${padding.xl};
      }
    `;
  }}
`;

const DrawerContainer = styled.div``;

export const Drawer = ({
  children,
  variant = 'default',
  customWidth,
  customPadding,
}: DrawerProps) => {
  return (
    <div>
      <Overlay>
        <DrawerWrapper
          $variant={variant}
          $customWidth={customWidth}
          $customPadding={customPadding}>
          <DrawerContainer>{children}</DrawerContainer>
        </DrawerWrapper>
      </Overlay>
    </div>
  );
};
